'use strict';

function getRules() {
    return {
        company:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        category:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        solutionLabel:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        contact:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        priority:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        complexity:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        influence:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        risk:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        completionDegree:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        description:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        title:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        origin:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        emergency:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        requesterName:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        currentDepartment:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        currentHandlerName:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
         ],
        currentHandler:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        handleComment:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        env:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        endTime:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        projectName:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],
        serviceClass:[
            {required: true, message: '不可为空', trigger: 'change,blur'},
        ],

    };
}
export {
    getRules
}
